module.exports = "/img/_/_/_/assets/images/creeper/battle/common//47.jpg?fb5527628f1cae1aeb508b4a8c1fefe4";